export const API_KEY = "AIzaSyDojfFeDesmYvBOrZS9CyEPCBT3JYS8OvA" as string;
export const MAP_GIVEN_ID = "8f99bf606d03d9d8" as string;
export const FIREBASE_API_KEY = "AIzaSyDFmTaCUjQNPo8CtWaHXq3brNAsZAHsaj8" as string;
export const FIREBASE_AUTH_DOMAIN = "cap-st-george-poi-map.firebaseapp.com" as string;
export const FIREBASE_PROJECT_ID = "cap-st-george-poi-map" as string;
export const FIREBASE_STORAGE_BUCKET = "cap-st-george-poi-map.appspot.com" as string;
export const FIREBASE_MESSAGING_SENDER_ID = "613233480500" as string;
export const FIREBASE_APP_ID = "1:613233480500:web:413055914585f3bc530b61" as string;
export const FIREBASE_MEASUREMENT_ID = "G-HTM2E286WK" as string;